import { AfterViewInit, Component, QueryList, ViewChildren } from '@angular/core';
import { CustomInputComponent } from '../../../shared-components/custom-input/custom-input.component';
import { ToasterService } from '../../../shared-components/custom-toaster/toaster.service';
import { ComponentType, FormValidationUtils } from '../../../utils/form-validation';
import { SmartFormBaseComponent } from '../../../utils/smart-form-base.component';
import { TranslateService } from '../../../services/translate/translate.service';

@Component({
	selector: 'app-inputs-form',
	templateUrl: './inputs-form.component.html',
	styleUrls: ['./inputs-form.component.scss'],
	standalone: false,
})
export class InputsFormComponent extends SmartFormBaseComponent implements AfterViewInit {
	public isVerified: boolean = false;

	public isSubmitting: boolean = false;

	@ViewChildren(CustomInputComponent) inputComponents!: QueryList<CustomInputComponent>;

	private readonly fieldConfigs = [
		{ name: 'username', type: ComponentType.INPUT },
		{ name: 'email', type: ComponentType.INPUT },
		{ name: 'password', type: ComponentType.INPUT },
	];

	constructor(
		private toasterService: ToasterService,
		private translateService: TranslateService
	) {
		super();
	}

	ngAfterViewInit(): void {
		this.initializeForm();
	}

	initializeForm(): void {
		this.formManager = FormValidationUtils.createSmartFormManagerWithQueryList(
			this.fieldConfigs,
			this.translateService,
			this.inputComponents
		);
	}

	onTestSubmit(event: Event): void {
		this.onSubmit(event);
		if (!this.isFormValid) {
			return;
		}
		this.simulateServerSubmission();
	}

	get username(): string {
		return this.formFields.username.value;
	}
	get email(): string {
		return this.formFields.email.value;
	}
	get password(): string {
		return this.formFields.password.value;
	}

	private simulateServerSubmission(): void {
		this.isSubmitting = true;
		console.log('Simulating server API call...');

		setTimeout(() => {
			let hasServerErrors = false;

			if (this.formFields.username.value === 'invalid') {
				this.toasterService.showError(
					this.translateService.translate('inputs-form.username-invalid-is-not-allowed-by-the-server', 'client')
				);
				hasServerErrors = true;
			}

			if (this.formFields.email.value === 'blocked@example.com') {
				this.toasterService.showError(this.translateService.translate('inputs-form.this-email-domain-is-blocked-by-our-server', 'client'));
				hasServerErrors = true;
			}

			if (this.formFields.password.value === 'password') {
				this.toasterService.showError(
					this.translateService.translate('inputs-form.password-password-is-too-weak-and-not-allowed', 'client')
				);
				hasServerErrors = true;
			}

			if (!hasServerErrors) {
				this.toasterService.showSuccess('Form submitted successfully!');
				console.log('Server submission successful');
			} else {
				console.log('Server validation failed');
			}
			this.isSubmitting = false;
		}, 2000); // Simulate network delay
	}
}
